

import eService from "../services/eServiceDataService";

export default {
  name: 'DirectorySearch',
  watch: {
    '$store.state.language': function() {
      this.lang = this.$store.state.language;
      this.updateData();
    }
  },
  created() {
    this.loading = true;
    document.title = "Manulife Insurances Directory";

    this.env = this.$store.state.env;
  },
  computed: {

  },
  mounted: async function () {

    await eService.getManulifePremierPlans().then(res => {
      this.apiData = res.data.recordset;
      this.updateData();
      this.loading = false;
    }).catch(e => {
      console.log(e);
    });

  },
  data () {
    return {
      env : '',
      separator: 'vertical',
      filter: '',
      pagination: {
        page: 0,
        rowsPerPage: 0
      },
      columns: [],
      apiData : [],
      data: [],
      source : {},
      lang : this.$store.state.language,
      loading: false,
      errorDialog: false,
      errorMessage: "",
      errorDialogBtn: "",
      title : "",
      pageCookie : JSON.parse(localStorage.getItem('pages')),
      remarks : "",
      group : [],
      obj : {}
    }
  },
  methods: {
    readDoc(event, row){

      //console.log(row);

      var pdf = row.pdf;

      //var path = (process.env.VUE_APP_ENV === 'prod' ? '/' : (process.env.VUE_APP_ENV === 'local' ? '/' : '/'))
      var pdfUrl = './pdf/manulife/'+pdf+'.pdf';

      var xhr = new XMLHttpRequest()
      xhr.open('HEAD', pdfUrl, false)
      xhr.send()

      if(xhr.status == '404'){
        alert('File is not existed. Please help to check with IT')
      }else{
        //this.$router.push({ name: 'ReadPDF', params: { pdf: pdfUrl } })
        window.open(pdfUrl, '_blank')
      }

    },
    updateData(){

      //console.log(this.apiData);
      var lang = this.lang;
      this.data = [];
      this.remarks = (this.pageCookie)[1]["remarks_"+this.lang];

      this.group = [];
      var obj = {};

      this.apiData.forEach(item => {

        if( !this.group.includes(item.type) ){
          this.group.push(item.type);
          obj[item.type]  = {};
          obj[item.type]["plans"]  = [];
          obj[item.type]["type_en"] = item.type_en;
          obj[item.type]["type_zh"] = item.type_zh;
        }

        obj[item.type]["plans"].push({
          name_en: item.plan_en,
          name_zh: item.plan_zh,
          contractCode : item.contractCode
        })

      });

      //console.log(obj);
      //console.log( JSON.stringify(obj) );
      this.obj = obj;

      this.columns = [
        {
          name : "label",
          field : "label",
          align: 'left',
          sortable: true
        }
      ];

      var temp = [];

      Object.keys(obj).forEach(function(key) {
        temp[key] = [];
        var val = obj[key]["plans"];
        val.forEach(ele => {
          temp[key].push(
              {
                label : ele['name_'+lang],
                pdf : ele.contractCode,
                align: 'center',
                sortable: true
              }
          )
        });
      });

      this.data = temp;

    },
    showTitle(type){
      return (this.obj)[type]["type_"+this.lang];
    }
  }
}
